import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';

import { MST3020_R01DetailDto, MST3020_R01Dto, MST3020_R01HeaderDto } from './Dto_MST3020_R01';
import { MST3020_R01Filter } from "./Store_MST3020_R01";

const baseUrl = `${config.apiUrl}/MST3020_R01`;

const getParams = (filter: Partial<MST3020_R01Filter>, listLength?: number) => {	
	return {
		brandCd: filter.brandCd || '',
		itemGroup: filter.itemGroup || '',
		itemAccount: filter.itemAccount || '',

		listLength: listLength || 0
	}
}

export const getMST3020_R01List = async (option: string, params: Partial<MST3020_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<MST3020_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getMST3020_R01AllCount = async (params: Partial<MST3020_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

export const getMST3020_R01DetailList = async (salBilNo: string) => {
	const url = `${baseUrl}/detail/${salBilNo}`;

	return await getData<ResponseDto<MST3020_R01DetailDto[]>>(url);
}

export const patchMST3020_R01 = async (data: MST3020_R01Dto) => {

	const url = `${baseUrl}`;

	return await patchData<MST3020_R01Dto, ResponseDto<MST3020_R01Dto[]>>(url, data);
}

export const deleteMST3020_R01 = async (itemCd: string) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<any>>(url, {
		params: {
			itemCd
		}
	});
}

export const downloadExcel_MST3020_R01 = async (option: string, salBillNo: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			salBillNo
		}
	})
}
export const getPdfBlob_MST3020_R01 = async (salBillNo: string): Promise<Blob> => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: { salBillNo },
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};